import React from "react";
import { useTranslation } from "react-i18next";

const ExclusivelyCraftedImage = () => {
  const { t } = useTranslation();
  return (
    <div data-w-id="3c2a31e5-f74d-9455-2511-df6b56a21cac" className="im-frame">
      <img
        src="/assets/logo/agapae-symbol-only-white.svg"
        alt={t("home.exclusivelyCrafted.logoAlt")}
        className="large-logo"
      />
      {/* The homepage's LCP element — `.im-frame` is `height: 50vw`, so this is
          the largest thing above the fold and the one image worth prioritising.
          `index.html` preloads the same URL.

          It carried a `srcSet` of 500w/1080w/1600w/2000w in which all four
          candidates were the *same* 1600x1066 file. That is not a no-op: it
          tells the browser a 2000w source exists, and it would also disagree
          with the preload (which declares no srcset), risking a second fetch of
          the same 221KB. Real variants are a build step; a fictional srcSet is
          worse than none. */}
      <img
        src="/assets/photos/agapae-hero.jpg"
        alt={t("home.exclusivelyCrafted.imageAlt")}
        width="1600"
        height="1066"
        fetchPriority="high"
        decoding="async"
        className="large-im"
      />
    </div>
  );
};

export default ExclusivelyCraftedImage;
